<template>
  <b-carousel class="detection-images" :controls="(item.files.length > 1 || item.detection_files.length > 1)" :indicators="(item.files.length > 1 || item.detection_files.length > 1)"
    img-width="300" img-height="300" background="#ababab" style="text-shadow: 1px 1px 2px #000;" :interval="0">
    <template v-if="item.files?.length">
    <b-carousel-slide v-for="file in item.files" :key="file.id">
        <template #img>
          <LOSPreviewSvg :info="{ ...item, files: [file] }" file_idx=0 img_type="sample" />

        </template>
      </b-carousel-slide>
    </template>

    <template v-else-if="item.detection_files?.length">
      <b-carousel-slide v-for="file in item.detection_files" :key="file.id">
        <template #img>
          <LOSPreviewSvg :info="{ ...item, detection_files: [file] }" file_idx=0 img_type="detection" />
        </template>
      </b-carousel-slide>
    </template>

    <template v-else>
      <b-carousel-slide>
        <template #img>
          <div>No files available {{item.detection_files?.length}}</div>
        </template>
      </b-carousel-slide>
    </template>
  </b-carousel>
</template>

<script>
import LOSPreviewSvg from '../LabelObjectSets/LOSPreviewSvg.vue';

export default {
  components: {
    LOSPreviewSvg
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.detection-images {
  max-width: 300px;

  .carousel-control-prev,
  .carousel-control-next {
    top: 50%;
    margin: -20px 0 0;
    background: #333;
    height: 40px;
    width: 40px;
  }
}

.carousel-indicators li {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.5);
  border: none
}
</style>
